<template>
  <div>This is the physical form</div>
</template>

<script>
export default {
  name: 'Physical'
}
</script>

<style scoped>

</style>
